<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div style="margin: 20px;">
        <el-radio-group v-model="status" @current-change="handleChange()" size="small">
          <el-radio-button label="1">联盟商家</el-radio-button>
          <el-radio-button label="2">运营中心</el-radio-button>
          <el-radio-button label="3">供货商</el-radio-button>
        </el-radio-group>
        <el-button @click="handleAdd" type="primary" size="small" style="margin-left: 100px;">新增机构</el-button>
      </div>
      <div class="supplierOperate">
        <el-input v-model="keywords" placeholder="请输入关键字"></el-input>
        <el-button @click="_getList" type="primary">搜索</el-button>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          @current-change="pageChange"
          :total="totalNum"
          v-if="paginationShow">
        </el-pagination>
      </div>
      <div class="supplierTable">
        <el-table
        ref="multipleTable"
        :data="userDatas"
        tooltip-effect="dark"
        style="width: 100%"
        border>
        <el-table-column
          prop="id"
          label="ID"
          width="60">
        </el-table-column>
        <el-table-column
          prop="name"
          label="供应商名称"
          width="160">
        </el-table-column>
        <el-table-column
          prop="contact"
          label="负责人"
          width="120">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系电话"
          width="120">
        </el-table-column>
        <el-table-column
          prop="address"
          label="地址"
          width="320">
        </el-table-column>
        <el-table-column
          prop="insertTime"
          label="注册时间"
          width="180">
        </el-table-column>
        <el-table-column
          prop="cfAdminVos.length"
          label="管理员人数"
          width="100">
        </el-table-column>
        <el-table-column label="操作"
          show-overflow-tooltip>
           <template slot-scope="scope">
            
            <el-button
             size="mini"
             @click="handleEdit(scope.$index, scope.row)">修改资料</el-button>
            <el-button
             size="mini"
             type="danger"
             @click="handleDelete(scope.$index, scope.row)">删除账号</el-button>
           </template>
         </el-table-column>
        </el-table>
      </div>
      <el-dialog title="修改供应商资料"
        :visible.sync="editDialogVisible"
        :append-to-body=true
        width="40%"
        :modal=false>
        <el-form label-position="left" label-width="80px" :model="controlData">
          <el-form-item label="名称:">
            <el-input v-model="controlData.name"></el-input>
          </el-form-item>
          <el-form-item label="负责人:">
            <el-input v-model="controlData.contact"></el-input>
          </el-form-item>
          <el-form-item label="联系电话:">
            <el-input v-model="controlData.phone"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_updateSupplier()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="deleteDialogVisible"
        width="20%"
        :append-to-body=true
        center>
        <span>确定要删除当前用户吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_deleteSupplier()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="管理员列表"
        :visible.sync="pushDialogVisible"
        :append-to-body=true
        width="60%"
        :modal=false>
        <el-table
        ref="multipleTable"
        :data="cfAdminVos"
        tooltip-effect="dark"
        style="width: 100%"
        border>
        <el-table-column
          prop="id"
          label="管理员ID"
          width="160">
        </el-table-column>
        <el-table-column
          prop="userName"
          label="管理员名称"
          width="160">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="160">
        </el-table-column>
        <el-table-column
          prop="insertTime"
          label="注册时间"
          width="220">
        </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="pushDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getAllSupplier, addSupplier, updateSupplier, deleteSupplier} from 'api/request'
import {getDepartment} from 'api/post'
import {ERR_OK} from 'api/config'
import {formatDate, loadingInstance, Success, Error} from 'common/js/util'
export default {
  components: { MSidebar,MHeader },
  data() {
    return {
      status: 1,
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      keywords: null,
      paginationShow: false,
      detailDialogVisible: false,
      pushDialogVisible: false,
      editDialogVisible: false,
      freezeDialogVisible: false,
      deleteDialogVisible: false,
      controlData: {},
      userDetail: [],
      userDatas: [],
      cfAdminVos: []
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    }else{
      this._getList();
    }
  },
  methods: {
    handleChange () {
      console.log(this.status)
    },
    pageChange (val) {
      console.log(val)
      this.pageNum = val
      this.userDatas = []
      this._getList()
    },
    handleAdd() {
      this.$router.push({
        path: '/addSupplier'
      })
    },
    handleEdit(index, row) {
      window.localStorage.setItem('supplierId',row.id);
      this.$router.push({
        path: '/addSupplier'
      })
    },
    handleDelete(index, row) {
      this.deleteDialogVisible = true;
      this.controlData = this.userDatas[index];
    },
    handleShowDetail(row) {
      this.detailDialogVisible = true;
      this.userDetail = [ row ];
    },
    handleShowPush(row) {
      this.cfAdminVos=row.cfAdminVos;
      this.pushDialogVisible = true;
    },
    _addSupplier(){
      let param = {
        name: this.controlData.name,
        phone: this.controlData.phone,
        contact: this.controlData.contact,
        userName: this.controlData.userName,
        password: this.controlData.password,
      }
      loadingInstance(Loading);
      addSupplier(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.addDialogVisible= false;
          this._getList();
        } else {
          Error(this, res);
        }
      })
    },
    _updateSupplier(){
      let param = {
        id: this.controlData.id,
        name: this.controlData.name,
        phone: this.controlData.phone,
        contact: this.controlData.contact,
      }
      loadingInstance(Loading);
      updateSupplier(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.editDialogVisible= false;
          this._getList();
        } else {
          Error(this, res);
        }
      })
    },
    _deleteSupplier(){
      let param = {
        id: this.controlData.id
      }
      loadingInstance(Loading);
      deleteSupplier(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.deleteDialogVisible=false;
          this._getList();
        } else {
          Error(this, res);
        }
      })
    },
    _getList () {
      let param = {
        keywords: this.keywords,
        current: this.pageNum,
        size: this.pageSize
      }
      loadingInstance(Loading)
      getAllSupplier(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.userDatas = res.data.records
          this.totalNum = res.data.total
          if(res.data.pages>1){
            this.paginationShow = true;
          }
        } else {
          Error(this, res)
        }
      })
    }
  },
}
</script>
<style scoped>
   .supplierOperate{
     height: 40px;
     margin: 20px;
     box-sizing: border-box;
   }
   .supplierTable{
     padding-left: 20px;
     padding-right: 20px;
     position: relative;
   }
</style>
<style>
  .supplierOperate .el-input {
    width:180px;
    height: 40px;
    margin-right: 10px;
    display: inline-block;
    float: left;
  }
  .supplierOperate .el-button {
    width:100px;
    height: 40px;
    display: inline-block;
    float: left;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/supplier/supplier.vue